import service from "../../images/homebanner.png"
import React from 'react'

const ServiceInterior = () => {
    return (
        <>
            <div className='container'>
                <h6 className='service-head '> ALL SERVICES</h6>
                <div className='row'>
                    <div className='col-lg-5'>
                        <img src={service} height={300} className='w-100 br-20' alt={service} />
                        <h3 className='color-primary  text-center mt-2'>Interior Design</h3>
                    </div>
                    <div className='col-lg-7 mt-5 mb-5'>
                        <h3>Elevate Your Space with Inspired Interior Design</h3>
                        <p>At AFS DOTE, we believe your home or office should be a reflection of your unique personality and lifestyle. Our expert interior designers blend creativity, functionality, and style to create spaces that are both beautiful and practical. Whether you're redesigning a single room or transforming an entire property, we provide tailored solutions that bring your vision to life.</p>
                        <p>
                        Our services include:</p>
                        <ul>
                            <li>Residential Interior Design – Customized designs that turn houses into homes.</li>
                            <li>Commercial Spaces – Stylish, functional interiors that inspire productivity.</li>
                            <li>Space Planning & Layout Optimization – Maximizing every square foot with smart design.</li>
                            <li>Color, Lighting & Material Selection – Thoughtfully curated elements for a cohesive look.</li>
                            <li>Furniture & Decor Styling – From sourcing to placement, we handle every detail.
                            From contemporary minimalism to timeless elegance, we work with a wide range of styles to suit your preferences. Let us transform your space into a masterpiece of comfort and design.</li>
                            </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceInterior
